/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { Editor } from 'primereact/editor';
import { TabMenu } from 'primereact/tabmenu';
import { SplitButton } from 'primereact/splitbutton';

import JustificationModal from '@components/JustificationModal';

import { validatePermissionAction } from '@actions/sessionPermission';

import { SET_VALUES_DOCUMENT } from '@constants/actionType';
import { LANGUAGE_DEFAULT, AuthorizedStatus } from '@constants/general';
import catalogPermissionsId from '@constants/catalogPermissionsId'

import store from '@store';

class ContentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: 0,
      loadingPage: true,
      errors: [],
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
    }

    this.initialValuesForm = {
      description: ''
    };

    /**
     * Control para evitar ciclo infinito cuando se pega contenido en el Editor.
     * Quill/PrimeReact puede disparar varios onTextChange mientras procesa el paste.
     */
    this.isPastingEditor = false;
    this.pasteTimeout = null;
    this.editorChangeTimeouts = {};

    this.actions = [
      {
        label: this.props.t('Cancelar'),
        command: (e) => { }
      }
    ]
  }

  componentDidMount() {
    const { keysLenguages, _content } = this.props;
    if (_content?.formattedText) {
      this.setState({
        ..._content.formattedText
      });
    } else {
      keysLenguages.map((item) =>
        this.setState({ [item]: { ...this.initialValuesForm } })
      );
    }
    this.validateOptionsSlit()
    this.setState({ loadingPage: false });
  }

  componentWillUnmount() {
    if (this.pasteTimeout) {
      clearTimeout(this.pasteTimeout);
    }

    Object.values(this.editorChangeTimeouts).forEach((timeout) => {
      clearTimeout(timeout);
    });
  }

  validateOptionsSlit = () => {
    const { isEdit, validatePermissionAction, estatus } = this.props
    if (isEdit) {
      // @Editar doc
      if (estatus !== AuthorizedStatus.STATUS_AUTHORIZED) {
        const canDeleteVersion = validatePermissionAction(catalogPermissionsId.ELIMINAR_DOCUMENTO)
        if (canDeleteVersion) {
          this.actions.unshift({
            label: this.props.t('Eliminar Version'),
            icon: 'pi pi-times',
            command: () => {
              this.props.deleteVersion()
            }
          })
        }
        const hasAuthorized = validatePermissionAction(catalogPermissionsId.AUTORIZAR_PUBLICACION_DE_DOCUMENTOS)
        if (hasAuthorized) {
          if (estatus !== AuthorizedStatus.STATUS_REJECTED) {
            this.actions.unshift({
              label: this.props.t('Rechazar'),
              icon: 'pi pi-exclamation-triangle',
              command: () => {
                this.props.reject()
              }
            })
          }
          this.actions.unshift({
            label: this.props.t('Autorizar'),
            icon: 'pi pi-check-circle',
            command: () => {
              this.onSubmit((justification) => this.props.authorize(justification))
            }
          })
        } else {
          if (estatus !== AuthorizedStatus.STATUS_PENDING) {
            this.actions.unshift({
              label: this.props.t('Enviar a autorizar'),
              icon: 'pi pi-envelope',
              command: () => {
                this.onSubmit((justification) => this.props.sendAuthorize(justification))

              }
            })
          }
        }
      }
    } else {
      // @Nueva doc
      const hasAuthorized = validatePermissionAction(catalogPermissionsId.AUTORIZAR_PUBLICACION_DE_DOCUMENTOS)
      if (hasAuthorized) {
        this.actions.unshift({
          label: this.props.t('Autorizar'),
          icon: 'pi pi-check-circle',
          command: () => {
            this.onSubmit((justification) => this.props.authorize(justification))
          }
        })
      } else {
        this.actions.unshift({
          label: this.props.t('Enviar a autorizar'),
          icon: 'pi pi-envelope',
          command: () => {
            this.onSubmit((justification) => this.props.sendAuthorize(justification))
          }
        })
      }
    }
  }

  onEditorPaste = () => {
    this.isPastingEditor = true;

    if (this.pasteTimeout) {
      clearTimeout(this.pasteTimeout);
    }

    this.pasteTimeout = setTimeout(() => {
      this.isPastingEditor = false;
    }, 300);
  };

  updateEditorState = (names, value) => {
    const [language, name] = names.split('-');
    const newValue = value || '';

    this.setState((prevState) => {
      const currentValue = prevState[language]?.[name] || '';

      if (currentValue === newValue) {
        return null;
      }

      const newState = {
        [language]: {
          ...prevState[language],
          [name]: newValue,
        },
      };

      if (prevState.errors[names] && newValue) {
        const errors = { ...prevState.errors };
        delete errors[names];

        newState.errors = errors;
      }

      return newState;
    });
  };

  onChangeEditor = (names, e) => {
    if (!e || typeof e.htmlValue === 'undefined') {
      return;
    }

    const newValue = e.htmlValue || '';

    if (this.isPastingEditor) {
      if (this.editorChangeTimeouts[names]) {
        clearTimeout(this.editorChangeTimeouts[names]);
      }

      this.editorChangeTimeouts[names] = setTimeout(() => {
        this.updateEditorState(names, newValue);
      }, 150);

      return;
    }

    this.updateEditorState(names, newValue);
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({ errors })
    }
  }

  validateFields = async () => {
    const { t } = this.props
    const { description } = this.state[LANGUAGE_DEFAULT]
    let errors = {}
    if (!description || description === '\n') errors = { ...errors, [`${LANGUAGE_DEFAULT}-description`]: `${t('Descripción')} ${t('es requerido')}` }
    this.setState({ errors })
    return errors
  }

  // onSubmit = async (e) => {
  //   e.preventDefault();
  //   const validate = await this.validateFields()
  //   if (some(validate, {})) return true
  //   const { success } = this.props;
  //   await this.setValuesToStateGlobal();
  //   return success();
  // };

  onSubmit = async (onAction) => {
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    const { t } = this.props;
    await this.setValuesToStateGlobal();
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        label: t('Justificación del cambio'),
        continueAction: ({ justification }) => onAction(justification),
      },
    });
  };

  setValuesToStateGlobal = async () => {
    const { keysLenguages } = this.props;
    const getValues = keysLenguages.reduce((accum, item) => {
      accum[item] = this.state[item];
      return accum;
    }, {});
    await store.dispatch({
      type: SET_VALUES_DOCUMENT,
      payload: {
        content: {
          formattedText: getValues
        }
      },
    });
    return true
  };

  render() {
    const { t, btnSubmitLoading, itemsTabsLenguages, keysLenguages, onBack, success } = this.props;
    const { activeTabIndex, loadingPage, errors, showModalJustification } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);

    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderByTabLenguage = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];

      return (
        <>
          <div
            className="p-col-12 p-field"
            onPasteCapture={this.onEditorPaste}
          >
            <Editor
              modules={{
                clipboard: {
                  matchVisual: false
                }
              }}
              name={`${prefixLenguage}-description`}
              style={{ height: '200px' }}
              value={this.state[prefixLenguage].description}
              onTextChange={(e) =>
                this.onChangeEditor(`${prefixLenguage}-description`, e)
              }
              className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-description`),
              })}
            />
            {getFormErrorMessage(`${prefixLenguage}-description`)}
          </div>
        </>
      );
    };

    if (loadingPage) return true;

    return (
      <>
        {/* <form onSubmit={this.onSubmit} autoComplete="false"> */}
        <div>
          <div className="p-fluid p-grid p-mb-4">
            <div className="p-col-12">
              {itemsTabsLenguages && (
                <TabMenu
                  model={itemsTabsLenguages}
                  activeIndex={activeTabIndex}
                  onTabChange={(e) =>
                    this.setState({ activeTabIndex: e.index })
                  }
                />
              )}
            </div>
            {renderByTabLenguage()}
          </div>

          <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />

              {/* <Button
                label={t('Continuar')}
                type="submit"
                className="p-button-primary"
                loading={btnSubmitLoading}
              /> */}

              <SplitButton
                label={t('Guardar')}
                icon="pi pi-save"
                onClick={() => this.onSubmit((justification) => success(justification))}
                model={this.actions}
              />
            </div>
          </div>

          <JustificationModal
            display={showModalJustification.isVisible}
            title={showModalJustification.title}
            description={showModalJustification.description}
            label={showModalJustification.label}
            onHidden={() => this.setState({ showModalJustification: { isVisible: false } })}
            onContinueAction={showModalJustification.continueAction}
          />
        </div>
        {/* </form> */}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _content: state.document.content,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  estatus: state.document.estatus
});

const mapDispatchToProps = {
  validatePermissionAction
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ContentForm);